import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, styled, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { isNotUndefinedOrNull } from "../FunctionsCore";
import { ForwardArrow } from "../icons/forward";
import { renderIdentifierGeneric } from "../RenderIdentifier";
import ThemeProvider from "../theme";
import { Container } from "../theme/common";
import { SPACING } from "../theme/palette";
const CardList = styled("div")(() => ({
    "--space": SPACING.spacexss,
    "display": "flex",
    "flexWrap": "wrap",
    "gap": "var(--space , clamp(0.75rem, calc(0.57rem + 0.88vw), 1.25rem))",
    "justifyContent": "center",
    "paddingTop": SPACING.spacexl,
}));
const Card = styled("div")(({ hasRating = false }) => (Object.assign({ "backgroundColor": "#f1f6f8", "borderRadius": "10px", "display": "grid", "flex": "1 0 20rem", "gap": SPACING.spacexs, "maxWidth": "37.5rem", "padding": SPACING.spacesM, "width": "100%" }, (() => hasRating ? ({
    "gridTemplateRows": "0fr 0fr 0fr 1fr 0fr"
}) : {})())));
const TopRowStyle = styled("div")(() => ({
    "alignItems": "start",
    "display": "flex",
    "gap": SPACING.spacexs
}));
const ImgStyle = styled("img")(({ theme }) => ({
    "background": theme.palette.common.white,
    "borderRadius": "10px",
    "maxWidth": "10rem",
    "padding": SPACING.space3xs
}));
const BlueTypography = styled(Typography)(({ theme }) => ({
    "color": theme.palette.primary.dark,
}));
const ButtonOverideStyle = styled(Button)(() => ({
    "&:hover": {
        "backgroundColor": "transparent",
        "textDecoration": "underline",
    },
    "borderRadius": 0,
    "maxWidth": "max-content",
    "paddingInline": 0,
}));
const NameStyle = styled(Typography)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.h4), { "color": theme.palette.primary.dark, "fontWeight": 650 })));
const JobPositionStyle = styled(Typography)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.subtitle1), { "color": theme.palette.primary.dark, "marginBottom": SPACING.space2xs, "marginTop": SPACING.space2xs })));
const ContainerStyle = styled("div")(({ theme }) => ({
    "backgroundColor": theme.palette.common.white,
    "paddingBlock": SPACING.space2xl,
}));
const HeadingStyle = styled(Typography)(({ theme }) => (Object.assign(Object.assign({}, theme.typography.h2), { "color": theme.palette.primary.dark, "textAlign": "center" })));
const ReviewInfoStyle = styled(Box)(() => ({
    "display": "flex",
    "flexDirection": "column",
    "height": "100%",
    "justifyContent": "center"
}));
const ProductTestimonialComponent = (props) => {
    const { cards, heading } = props;
    return (_jsx(ThemeProvider, { children: _jsx(ContainerStyle, { children: _jsxs(Container, { children: [_jsx(HeadingStyle, { children: heading }), _jsx(_Fragment, { children: isNotUndefinedOrNull(cards) && cards.length > 0 ? (_jsx(CardList, { children: cards.map((card, index) => {
                                var _a;
                                return (_jsxs(Card, Object.assign({ hasRating: isNotUndefinedOrNull(card.rating) }, { children: [_jsxs(TopRowStyle, { children: [isNotUndefinedOrNull(card.logoPath) && card.logoPath.length > 0 ?
                                                    _jsx(ImgStyle, { alt: card.name, src: card.logoPath }) :
                                                    (_jsx(_Fragment, {})), _jsxs(ReviewInfoStyle, { children: [isNotUndefinedOrNull(card.name) ? _jsx(NameStyle, { children: card.name }) : _jsx(_Fragment, {}), isNotUndefinedOrNull(card.position) ? _jsx(JobPositionStyle, { children: card.position }) : _jsx(_Fragment, {})] })] }), isNotUndefinedOrNull(card.rating) ? card.rating : _jsx(_Fragment, {}), isNotUndefinedOrNull(card.reviewHeading) ? _jsx(BlueTypography, Object.assign({ variant: "h4" }, { children: card.reviewHeading })) : _jsx(_Fragment, {}), isNotUndefinedOrNull(card.review) ? _jsx(Typography, Object.assign({ variant: "h5" }, { children: card.review })) : _jsx(_Fragment, {}), isNotUndefinedOrNull(card.buttonLink) && isNotUndefinedOrNull(card.buttonText) ? (_jsxs(ButtonOverideStyle, Object.assign({ href: card.buttonLink, size: "medium" }, (((_a = card.openInNewTab) !== null && _a !== void 0 ? _a : false) ? { "target": "_blank" } : {}), { variant: "text" }, { children: [card.buttonText, " ", _jsx(ForwardArrow, { width: "14px" })] }))) : (_jsx(_Fragment, { children: " " }))] }), `${card.name}-${index}`));
                            }) })) : (_jsx(_Fragment, {})) })] }) }) }));
};
const productTestimonial = (renderableData) => renderIdentifierGeneric(ProductTestimonialComponent, renderableData);
export { productTestimonial, ProductTestimonialComponent };
